export const CREATE_CONTACT = 'CREATE_CONTACT';
export const GET_CONTACT = 'GET_CONTACT';
export const GET_CONTACTS = 'GET_CONTACTS';
export const UPDATE_CONTACT = 'UPDATE_CONTACT';
export const CLEAR_CONTACT = 'CLEAR_CONTACT';
